// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1h9YL","author":"Table_author__2g9k1","authorImage":"Table_authorImage__39l4g","unreadRow":"Table_unreadRow__25aq2"};